<div
  class="status p-3 text-center shadow position-fixed end-0 w-100"
  style="z-index: 9999"
  [class.hidden]="this.ocultarPopup === true"
  [class.offline]="(this.statusConexao$ | async) === false"
>
  <b>{{
    (this.statusConexao$ | async) === false ? this.semConexao : this.comConexao
  }}</b>
  <!-- <button
    type="button"
    class="btn-close btn-sm text-reset position-absolute top-0 end-0 mt-1 me-1"
    (click)="this.ocultarPopup = true"
  ></button> -->
</div>
